(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["customer-review"]) return;
  try {
    
  
jQuery(document).ready(function() {
    jQuery("#news-slider").owlCarousel({
        loop:true,
        items : 3,
        itemsDesktop:[1199,3],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:true,
        autoPlay:true,
        navigationText:["",""],
        paginationSpeed: 500,
        autoplayTimeout: 3000,
        pagination:true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-in-home"]) return;
  try {
    
jQuery(document).ready(function() {
    jQuery("#fe-slider").owlCarousel({
        loop:true,
        items : 4,
        itemsDesktop:[1199,4],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:false,
        autoPlay:true,
      paginationSpeed: 500,
        autoPlay: 2500,
        pagination:true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-slider-home"]) return;
  try {
    
var swiper = new Swiper('.mySwiper99', {
  slidesPerView: 4,
  loop: true,
  speed: 5000,
  dots: true,
  autoplay: {
    enabled: true,
    delay: 1,
  },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner-mobile"]) return;
  try {
    
jQuery(document).ready(function() {
    jQuery("#homebanner-sliderm").owlCarousel({
        loop:true,
        items : 2,
        itemsDesktop:[1199,2],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:false,
        autoPlay:true,
        navigationText:["",""],
        pagination:true
      
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-banner"]) return;
  try {
    
jQuery(document).ready(function() {
    jQuery("#homebanner-slider").owlCarousel({
        loop:true,
        items : 2,
        itemsDesktop:[1199,2],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:false,
        autoPlay:true,
        navigationText:["",""],
        pagination:true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["khuraq-family-team"]) return;
  try {
    
jQuery(document).ready(function() {
    jQuery("#team-slider").owlCarousel({
        loop:true,
        items : 3,
        itemsDesktop:[1199,3],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:false,
        autoPlay:true,
      paginationSpeed: 500,
        autoPlay: 2500,
        pagination:true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-biotin-logo-slider"]) return;
  try {
    
var swiper77 = new Swiper('.mySwiper77', {
  slidesPerView: 6,
  loop: true,
  speed: 5000,
  dots: true,
  autoplay: {
    enabled: true,
    delay: 1,
  },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-customer-review"] && !window.DesignMode) return;
  try {
    
  
jQuery(document).ready(function() {
    jQuery("#news-slider").owlCarousel({
        loop:true,
        items : 3,
        itemsDesktop:[1199,3],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:true,
        autoPlay:true,
        navigationText:["",""],
        pagination:true
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qr-code-free-diet-plan"]) return;
  try {
    
var swiper = new Swiper('.mySwiper99', {
  slidesPerView: 3,
  loop: true,
  speed: 5000,
  dots: true,
  autoplay: {
    enabled: true,
    delay: 1,
  },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-home-one"]) return;
  try {
    
jQuery(document).ready(function() {
    jQuery("#homebanner-sliders").owlCarousel({
        loop:false,
        items : 2,
        itemsDesktop:[1199,2],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:false,
        autoPlay:false,
        navigationText:["",""],
        pagination:false
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-home-two"]) return;
  try {
    
  
jQuery(document).ready(function() {
    jQuery("#news-slider").owlCarousel({
        loop:true,
        items : 3,
        itemsDesktop:[1199,3],
        itemsDesktopSmall:[980,2],
        itemsMobile : [600,1],
        navigation:true,
        autoPlay:true,
        navigationText:["",""],
        pagination:false
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweta-slider"]) return;
  try {
    
var swiper = new Swiper('.mySwiper', {
  slidesPerView: 'auto',
  loop: true,
  speed: 5000,
  dots: true,
  autoplay: {
    enabled: true,
    delay: 1,
  },
    });

  } catch(e) { console.error(e); }
})();

})();
